<template>
  <vs-popup :active="opened" title="Assign by Email" class-content="content-full" button-close-hidden>
    <form id="assign-by-email-form" autocomplete="off">
      <vs-row vs-justify="center" vs-align="center">
        <vs-col vs-w="11" class="py-10">
          <vs-row>
            <vs-col>
              <p class="font-bold mb-4">{{ sessionResource.title }}</p>
              <p>An email will be sent to your client with a link to this session/exercise. </p>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row vs-justify="center" vs-align="center">
        <vs-col vs-w="11" class="py-10">
          <vs-row>
            <vs-col>
              <vs-textarea class="w-full" rows="5"
                           v-validate="''"
                           name="message"
                           v-model="form.message">
              </vs-textarea>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row ref="buttons">
        <vs-col vs-w="4" class="px-5 py-2 text-right">
          <vs-button color="primary" type="flat" @click.native="preview" class="vs-con-loading__container"
                     ref="cancelButton">
            {{ $t('assign_by_email.buttons.preview') }}
          </vs-button>
        </vs-col>
        <vs-col vs-w="4" class="px-5 py-2 text-center">
          <vs-button size="large" color="primary" type="filled" @click.native="send" class="vs-con-loading__container"
                     ref="sendButton">
            {{ $t('assign_by_email.buttons.send') }}
          </vs-button>
        </vs-col>
        <vs-col vs-w="4" class="px-5 py-2 text-left">
          <vs-button color="primary" type="border" @click.native="cancel" class="vs-con-loading__container"
                     ref="cancelButton">
            {{ $t('assign_by_email.buttons.cancel') }}
          </vs-button>
        </vs-col>
      </vs-row>
    </form>
    <assign-by-email-preview ref="previewButton"
                             :opened="!!previewHtml"
                             :html="previewHtml"
                             @close="previewHtml=null"/>
  </vs-popup>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import AssignByEmailPreview from '@/views/app/view_member/progress/assign/assign-by-email-preview.vue';


const escapeTags = (value) => {
  if (typeof value === 'string') return value.replace(/</g, '--').replace(/>/g, '--');
  return value;
};

export default {
  name: 'assign-by-email',
  components: {AssignByEmailPreview},
  props: {
    sessionResource: ResourceImpl,
    opened: Boolean
  },
  data () {
    return {
      previewHtml: null,
      form: {
        message: ''
      }
    };
  },
  methods: {
    preview (evt) {
      const button = evt.target.closest('.vs-button');
      this.$vs.loading({
        container: button,
        scale: 0.45,
        background: 'primary',
        opacity: 1,
        color: '#fff'
      });
      this.$http.post(this.sessionResource.$href('assign-by-email-preview'), {
        message: escapeTags(this.form.message)
      }).then(res => {
        this.previewHtml = res.data;
      }).finally(() => {
        this.$vs.loading.close(button);
      });
    },
    send (evt) {
      const button = evt.target.closest('.vs-button');
      this.$vs.loading({
        container: button,
        scale: 0.45,
        background: 'primary',
        opacity: 1,
        color: '#fff'
      });
      this.$http.post(this.sessionResource.$href('assign-by-email'), {
        message: escapeTags(this.form.message)
      }).then(() => {
        this.$vs.notify({
          title: 'Assigned to member',
          text: `An email has been sent to the member for <b>${this.sessionResource.title}</b>.`,
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'success'
        });
        this.$emit('sent');
      }).finally(() => {
        this.$vs.loading.close(button);
      });
    },
    cancel () {
      this.form = {message: ''};
      this.$emit('cancel');
    }
  }
};
</script>


<style scoped>

</style>
